import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TaskReminderRefreshService {
  private readonly refresh$ = new Subject<void>();

  readonly onRefresh$ = this.refresh$.asObservable();

  notify(): void {
    this.refresh$.next();
  }
}
